<template>
	<b-modal
		size="xl"
		id="modal-detail-tag"
		centered
		scrollable
		:title="metaData.name"
		ok-only
		dialog-class="large-modal"
		@show="getListDepartment"
	>
		<div class="modal-content">
			<div class="card">
				<div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-6 gx-5 gy-3 card-body">
					<div class="col">
						<div class="row align-items-center">
							<div class="col-auto">
								<div class="avatar avatar-sm">
									<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
										<i class="fe fe-calendar"></i>
									</div>
								</div>
							</div>
							<div class="col ms-n2">
								<h4 class="mb-1 font-weight-bold">Created At</h4>
								<small class="text-body-secondary"
									><span> {{ createdAt }}</span>
								</small>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="row align-items-center">
							<div class="col-auto">
								<div class="avatar avatar-sm">
									<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
										<i class="fe fe-user"></i>
									</div>
								</div>
							</div>
							<div class="col ms-n2">
								<h4 class="mb-1 font-weight-bold">Created By</h4>
								<small class="text-body-secondary"
									><span> {{ createdBy }}</span>
								</small>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="row align-items-center">
							<div class="col-auto">
								<div class="avatar avatar-sm">
									<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
										<i class="fe fe-calendar"></i>
									</div>
								</div>
							</div>
							<div class="col ms-n2">
								<h4 class="mb-1 font-weight-bold">Updated At</h4>
								<small class="text-body-secondary"
									><span> {{ updatedAt }}</span>
								</small>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="row align-items-center">
							<div class="col-auto">
								<div class="avatar avatar-sm">
									<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
										<i class="fe fe-user"></i>
									</div>
								</div>
							</div>
							<div class="col ms-n2">
								<h4 class="mb-1 font-weight-bold">Updated By</h4>
								<small class="text-body-secondary"
									><span> {{ updatedBy }}</span>
								</small>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="row align-items-center">
							<div class="col-auto">
								<div class="avatar avatar-sm">
									<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
										<i class="fe fe-clipboard"></i>
									</div>
								</div>
							</div>
							<div class="col ms-n2">
								<h4 class="mb-1 font-weight-bold">Total Row Opex</h4>
								<small class="text-body-secondary"
									><span> {{ dataDetail?.opex?.length }}</span>
								</small>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="row align-items-center">
							<div class="col-auto">
								<div class="avatar avatar-sm">
									<div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
										<i class="fe fe-clipboard"></i>
									</div>
								</div>
							</div>
							<div class="col ms-n2">
								<h4 class="mb-1 font-weight-bold">Total Row Capex</h4>
								<small class="text-body-secondary"
									><span> {{ dataDetail?.capex?.length }}</span>
								</small>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-body">
					<div class="row">
						<div class="col">
							Filter Department:
							<v-select
								:options="listDepartment"
								:reduce="(e) => e.department_code"
								v-model="filterOptions.department_code"
								label="department_name"
								class="mt-1"
								@input="handleFilter()"
							/>
						</div>
						<div class="col">
							Filter Plan:
							<v-select
								:options="listPlan"
								:reduce="(e) => e.plan_id"
								v-model="filterOptions.plan_id"
								label="plan_name"
								class="mt-1"
							/>
						</div>
					</div>
				</div>
			</div>
			<b-tabs pills card fill>
				<b-tab :title="`OPEX : ${sumOpex}`">
					<vue-good-table
						:line-numbers="true"
						:columns="opexColumns"
						:rows="dataDetail?.opex"
						ref="tableOPEX"
						:sort-options="{
							enabled: true,
						}"
						:pagination-options="{
							enabled: true,
							perPage: paginationOptions.perPage,
							setCurrentPage: paginationOptions.currentPage,
							aselole: 'asdad',
						}"
						style-class="vgt-table border-0 table"
						@on-sort-change="handleShortChange()"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'po_value'"> Rp. {{ convertNumber(parseFloat(props.row.po_value)) }} </span>
						</template>
						<template slot="pagination-bottom" slot-scope="props">
							<div class="d-flex justify-content-end">
								<div>
									<b-pagination
										v-model="paginationOptions.currentPage"
										:total-rows="props.total"
										:per-page="paginationOptions.perPage"
										first-number
										last-number
										align="right"
										prev-class="prev-item"
										next-class="next-item"
										class="mr-3 mb-4 mt-0"
										@input="(page) => props.pageChanged({ currentPage: page })"
									>
									</b-pagination>
								</div>
							</div>
						</template>
					</vue-good-table>
				</b-tab>
				<b-tab :title="`CAPEX : ${sumCapex}`">
					<vue-good-table
						:line-numbers="true"
						:columns="opexColumns"
						:rows="dataDetail?.capex"
						ref="tableCAPEX"
						:sort-options="{
							enabled: true,
						}"
						:pagination-options="{
							enabled: true,
							perPage: paginationOptions.perPage,
							setCurrentPage: paginationOptions.currentPage,
						}"
						style-class="vgt-table border-0 table"
						@on-sort-change="handleShortChange()"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'po_value'"> Rp. {{ convertNumber(parseFloat(props.row.po_value)) }} </span>
						</template>
						<template slot="pagination-bottom" slot-scope="props">
							<div class="d-flex justify-content-end">
								<div>
									<b-pagination
										v-model="paginationOptions.currentPage"
										:total-rows="props.total"
										:per-page="paginationOptions.perPage"
										first-number
										last-number
										align="right"
										prev-class="prev-item"
										next-class="next-item"
										class="mr-3 mb-4 mt-0"
										@input="(page) => props.pageChanged({ currentPage: page })"
									>
									</b-pagination>
								</div>
							</div>
						</template>
					</vue-good-table>
				</b-tab>
			</b-tabs>
		</div>
	</b-modal>
</template>

<script>
import moment from 'moment';
export default {
	name: 'ModalDetailProjectTag',
	props: { metaData: Object },
	data() {
		return {
			opexColumns: [
				{
					label: 'GL',
					field: 'gl_code',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Budget Task',
					field: 'task_name',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'PR Number',
					field: 'pr_number',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'PR Date',
					field: 'pr_date',
					sortable: true,
					type: 'date',
					dateInputFormat: 'yyyy-MM-dd',
					dateOutputFormat: 'd MMM yyyy',
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'PO Number',
					field: 'po_number',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'PO Date',
					field: 'po_date',
					sortable: true,
					type: 'date',
					dateInputFormat: 'yyyy-MM-dd',
					dateOutputFormat: 'd MMM yyyy',
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'PO Value',
					field: 'po_value',
					sortable: true,
					type: 'number',
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Contract Name',
					field: 'contract_name',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Contract Detail',
					field: 'contract_detail',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Internal Memo',
					field: 'file_name',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
			],
			capexColumns: [
				{
					label: 'GL',
					field: 'gl_code',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Budget Task',
					field: 'task_name',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'PR Number',
					field: 'pr_number',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'PR Date',
					field: 'pr_date',
					sortable: true,
					type: 'date',
					dateInputFormat: 'yyyy-MM-dd',
					dateOutputFormat: 'd MMM yyyy',
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'PO Number',
					field: 'po_number',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'PO Date',
					field: 'po_date',
					sortable: true,
					type: 'date',
					dateInputFormat: 'yyyy-MM-dd',
					dateOutputFormat: 'd MMM yyyy',
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'PO Value',
					field: 'po_value',
					sortable: true,
					type: 'number',
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Contract Name',
					field: 'contract_name',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Contract Detail',
					field: 'contract_detail',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
				{
					label: 'Internal Memo',
					field: 'file_name',
					sortable: false,
					thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					tdClass: 'no-wrap color-secondary align-middle',
				},
			],
			paginationOptions: {
				perPage: 5,
				currentPage: 1,
			},
			filterOptions: {
				department_code: '',
				plan_id: '',
			},
			listDepartment: [],
			listPlan: [],
		};
	},
	methods: {
		convertNumber(dat) {
			const number = dat || 0;
			return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
		},
		handleShortChange() {
			this.paginationOptions.currentPage = 1;
			console.log('perPage', this.$refs.tableOPEX.aselole);
		},
		getListDepartment() {
			this.listDepartment = [];
			this.filterOptions.department_code = '';
			const departmentMap = new Map();
			const processArray = (arr) => {
				arr?.forEach(({ department_code, fund_center, department_name }) => {
					if (!departmentMap.has(department_code)) {
						departmentMap.set(department_code, {
							department_code,
							fund_center,
							department_name: `${fund_center} - ${department_name}`,
						});
					}
				});
			};

			processArray(this.dataDetail?.opex);
			processArray(this.dataDetail?.capex);

			this.listDepartment = [...departmentMap.values()];
			this.getListPlan();
		},
		getListPlan() {
			const plans = new Map();
			const processArray = (arr) => {
				arr?.forEach(({ plan_id, plan_year, plan_name, plan_version }) => {
					if (!plans.has(plan_id)) {
						plans.set(plan_id, {
							plan_id,
							plan_year,
							plan_name: `${plan_year} - ${plan_name} version ${plan_version}`,
						});
					}
				});
			};

			processArray(this.dataDetail?.opex);
			processArray(this.dataDetail?.capex);

			this.listPlan = [...plans.values()];
		},
		handleFilter() {
			this.filterOptions.plan_id = '';
			this.getListPlan();
		},
	},
	computed: {
		dataDetail() {
			const allData = this.$store.getters['projectTag/detail'];
			let filteredData = allData;
			if (this.filterOptions.department_code) {
				filteredData = {
					opex: allData.opex.filter((e) => e.department_code === this.filterOptions.department_code),
					capex: allData.capex.filter((e) => e.department_code === this.filterOptions.department_code),
				};
			}
			if (this.filterOptions.year) {
				filteredData = {
					opex: filteredData.opex.filter((e) => e.year === this.filterOptions.year),
					capex: filteredData.capex.filter((e) => e.year === this.filterOptions.year),
				};
			}
			if (this.filterOptions.plan_id) {
				filteredData = {
					opex: filteredData.opex.filter((e) => e.plan_id === this.filterOptions.plan_id),
					capex: filteredData.capex.filter((e) => e.plan_id === this.filterOptions.plan_id),
				};
			}

			return filteredData;
		},
		createdAt() {
			return this.metaData?.created_at ? moment(this.metaData?.created_at).format('DD MMM YYYY HH:mm') : '-';
		},
		updatedAt() {
			return this.metaData?.updated_at ? moment(this.metaData?.updated_at).format('DD MMM YYYY HH:mm') : '-';
		},
		createdBy() {
			return `${this.metaData?.created_by_name ? this.metaData?.created_by_name : '-'} ${
				this.metaData?.created_by_department ? ' - ' + this.metaData?.created_by_department : ''
			}`;
		},
		updatedBy() {
			return `${this.metaData?.updated_by_name ? this.metaData?.updated_by_name : '-'} ${
				this.metaData?.updated_by_department ? ' - ' + this.metaData?.updated_by_department : ''
			}`;
		},
		sumOpex() {
			return `Rp ${this.convertNumber(this.dataDetail?.opex?.reduce((acc, cur) => acc + parseInt(cur.po_value), 0))}`;
		},
		sumCapex() {
			return `Rp ${this.convertNumber(this.dataDetail?.capex?.reduce((acc, cur) => acc + parseInt(cur.po_value), 0))}`;
		},
	},
};
</script>
<style>
.large-modal {
	min-width: 95vw !important;
	margin: 2.5% auto;
}
</style>
